import { Switchboard } from "../../lib/events";
import { ToolbarButton } from "../../lib/ui/toolbar/buttons";
export class CurrentLocationButton extends ToolbarButton {
    constructor(loc_layer) {
        super('bullseye', 'Track Current Location', 'clButton');
        this.loc_layer = loc_layer;
        this.err_receiver = Switchboard.get_receiver("BUFFER_ERR");
        this.is_on = false;
    }
    _action(e) {
        this.is_on = !this.is_on;
        if (this.is_on) {
            this.loc_layer.show();
        }
        else {
            this.loc_layer.hide();
        }
    }
}
